import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../../components/apiconfig/api-config';

const DeliveryOrderView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_BASE_URL}/api/sales/delivery-order-get/${id}`, {
          method: 'GET',
          credentials: 'include',
        });
        if (!res.ok) throw new Error('Failed to fetch');
        const result = await res.json();
        setData(result.data);
      } catch (err) {
        setError('Failed to load data');
      }
      setLoading(false);
    };
    fetchData();
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  if (loading) return <div className="text-center py-8">Loading...</div>;
  if (error) return <div className="text-center text-red-600 py-8">{error}</div>;
  if (!data) return <div className="text-center py-8">No data found.</div>;

  // Use only DB data, no dummy values

  const staticQty = data.quantity_mt || '';
  const staticLocation = data.warehouse_location || '';
  const staticState = data.warehouse_state || '';
  const staticVessel = data.vessel_name || '';
  const staticWarehouse = data.warehouse_name || '';
  const staticCompany = data.buyer_name || '';
  const staticDONumber = data.do_number || '';
  const staticDate = data.do_date ? new Date(data.do_date).toLocaleDateString('en-GB') : '';
  
  // CMA/CHA details

  const cmaName = data.cma_cha_name || '';
  const cmaAddress = data.cma_cha_address || '';
  
  // Commodity details
  const commodityName = data.commodity_name || '';
  const quantityMT = data.quantity_mt || '';

  return (
    <div className="max-w-3xl mx-auto bg-white p-6 border rounded shadow print:shadow-none print:border-0 print:p-4 print:max-w-full print:bg-white" style={{minHeight: '100vh'}}>
      <div className="flex justify-between items-center mb-4 print:hidden">
        <button onClick={() => navigate(-1)} className="text-[#3899cf] hover:underline">Back</button>
        <button onClick={handlePrint} className="bg-[#3899cf] hover:bg-[#0e8dc6] text-white px-4 py-2 rounded">Print</button>
      </div>
      
      {/* Header */}
      <div className="mb-5 print:mb-8 text-left">
        <h1 className="text-lg font-bold tracking-wide">KRIBHCO AGRI BUSINESS LIMITED</h1>
        <div className="text-xs">(A wholly owned subsidiary of KRIBHCO)</div>
      </div>
      
      <div className="text-center mb-6 print:mb-9">
        <h2 className="text-base font-semibold underline">Delivery Order</h2>
      </div>
      
      {/* Date and DO Number */}
      <div className="mb-5 print:mb-8 text-sm">
        <div>Date: {staticDate}</div>
        <div>Delivery Order No: {staticDONumber}</div>
      </div>
      
      {/* To Address - CMA/CHA Name */}
      <div className="mb-5 print:mb-8 text-sm">
        <div>To,</div>
        <div className="font-semibold">{cmaName}</div>
        {cmaAddress && <div>{cmaAddress}</div>}
      </div>
      
      {/* Subject */}
      <div className="mb-5 print:mb-8 text-sm">
        <span className="font-semibold">Subject:</span> Delivery Order of {commodityName} {quantityMT} MT. D O Will be valid till next 10 days.
       
      </div>
      
      {/* Body */}
      <div className="mb-5 print:mb-8 text-sm">
        <div>Dear Sir/Madam,</div>
        <div className="mt-4 print:mt-7"> We hereby authorize you for lifting of {quantityMT} MT {commodityName} from {staticLocation} as per details given below:</div>
      </div>
      
      {/* Table */}
      <table className="w-full border text-xs mb-5 print:mb-8">
        <thead> 
          <tr className="bg-gray-100">
            <th className="border px-2 py-1">Sr. No</th>
            <th className="border px-2 py-1">DO.NO</th>
            <th className="border px-2 py-1">Name of Buyer</th>
            <th className="border px-2 py-1">Name of the Vessel</th>
            <th className="border px-2 py-1">Name of Warehouse</th>
            <th className="border px-2 py-1">Location</th>
            <th className="border px-2 py-1">Qty In. MT</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border px-2 py-1 text-center">1</td>
            <td className="border px-2 py-1">{staticDONumber}</td>
            <td className="border px-2 py-1">{staticCompany}</td>
            <td className="border px-2 py-1">{staticVessel || '-'}</td>
            <td className="border px-2 py-1">{staticWarehouse}</td>
            <td className="border px-2 py-1">{staticLocation}<br/>{staticState}</td>
            <td className="border px-2 py-1 text-right">{staticQty}</td>
          </tr>
        </tbody>
      </table>
      
      {/* Note */}
      <div className="mb-5 print:mb-8 text-sm">Kindly do the needful for delivery of the material and share with us the delivery details.</div>
     
   {/* Signature and Thanking you */}
<div className="mb-5 print:mb-8 text-sm">
  <div>
    Thanking you<br/>
    For KRIBHCO AGRI BUSINESS LIMITED
  </div>
  {/* Signature if available */}
  {data.authority_signature && (
    <div>
      <img 
        src={`${API_BASE_URL}/uploads/${data.authority_signature}`} 
        alt="Signature" 
        className="h-12 w-auto mt-5 print:mt-8"
        style={{height: '60px', maxWidth: '200px'}}
        onError={(e) => { e.target.style.display = 'none'; }}
      />
      <div className="mt-2">Authorised Signatory</div>
    </div>
  )}
</div>

      
      {/* Logo */}
      <div className="flex justify-center mb-5 print:mb-8">
        <img src="/KribhcoLogo.png" alt="KRIBHCO Logo" className="h-12 w-auto" style={{minWidth:'48px'}} />
      </div>
      
      {/* Footer */}
      <div className="text-xs border-t pt-4 print:pt-7 text-center">
        Kribhco Bhawan, A-10, Sector-1, Noida-201301, Dist. Gautam Budh Nagar (U.P.), India<br/>
        Phone: +91 120 4222555 | www.kribhcoagri.in<br/>
        Regd. Office: A-60, Kailash Colony, New Delhi-110048 | CIN: U01110DL2022PLC393197
      </div>
    </div>
  );
};

export default DeliveryOrderView; 